var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('content-default', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "w-full"
        }, [_c('div', {
          staticClass: "title gph-underline"
        }, [_vm._v(_vm._s(_vm.$t('Login')))]), _c('div', {
          staticClass: "mb-[1rem]"
        }, [_vm._v(" " + _vm._s(_vm.$t('Need a new account?')) + " "), _c('router-link', {
          staticClass: "link",
          attrs: {
            "to": "/crm/registration"
          }
        }, [_vm._v(_vm._s(_vm.$t('Create an account')))])], 1), _vm.errMsg ? _c('login-fail', {
          attrs: {
            "message": _vm.errorMessage
          }
        }) : _vm._e(), _c('div', {
          staticClass: "py-3"
        }, [_vm.state == 'phone' ? _c('login-phone-no', {
          on: {
            "switched": function ($event) {
              _vm.state = 'member';
            },
            "showErr": function ($event) {
              return _vm.showErrorMessage($event);
            }
          }
        }) : _vm._e(), _vm.state == 'member' ? _c('login-member-no', {
          on: {
            "switched": function ($event) {
              _vm.state = 'phone';
            },
            "showErr": function ($event) {
              return _vm.showErrorMessage($event);
            }
          }
        }) : _vm._e(), _c('div', {
          staticClass: "fs-16 text-center xl:text-end mb-16"
        }, [_c('router-link', {
          staticClass: "link gph-underline !text-[#0B1D35] !font-semibold",
          attrs: {
            "to": "forget-password"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('Forgot password?')))])], 1), _c('div', {
          staticClass: "xl:hidden"
        }, [_vm.$route.path == '/crm/' ? _c('router-link', {
          attrs: {
            "to": "/crm/transfer-existing-account"
          }
        }, [_c('div', {
          staticClass: "btn !w-full !text-[#0B1D35] !border-[#78C178]"
        }, [_vm._v(_vm._s(_vm.$t('Transfer Existing Account')))])]) : _vm._e(), _vm.$route.path == '/crm/registration' ? _c('router-link', {
          attrs: {
            "to": "/crm/transfer-existing-account"
          }
        }, [_c('a', {
          staticClass: "btn",
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v(_vm._s(_vm.$t('Transfer Existing Account')))])]) : _vm._e()], 1)], 1)], 1)];
      },
      proxy: true
    }])
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };